import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import { PrescriptionFooter } from '../../Components/Prescription Footer/PrescriptionFooter';
import { fetchPatientDetailsUuid, postPrescriptionTemplate } from '../../Redux/Thunk/Actions';
import './PretermLabour.scss';

export default function PretermLabour(props) {
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: '',
    name: '',
    date: '',
    time: '',
    status: 'Not Visited',
    notes: '',
    patient_id: ''
  });

  const [patientOne_UUId, setPatientOne_UUId] = useState('');

  const checkListHeaders = [
    {key: 'date', label: 'Date', inputType: 'date'},
    {key: 'hvs', label: 'HVS'},
    {key: 'urine_culture', label: 'Urine Culture'},
    {key: 'cervical_length', label: 'Cervical Length'},
    {key: 'wbc', label: 'WBC'},
    {key: 'medications', label: 'Medications'}
  ];

  const [checkListRows, setCheckListRows] = useState([
    {date: '', hvs: '', urine_culture: '', cervical_length: '', wbc: '', medications: ''}
  ]);

  const [showTables, setShowTables] = useState({
    checkList: true
  });

  const handleNill = id => {
    setShowTables(prev => ({...prev, [id]: false}));
  };

  const handleChange = e => {
    var text = e.target.value;

    if (e.target.name === 'patientId1') {
      if (e.target.value.length === 10 && e.target.value.charAt(0) === 'A') {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value
          };
          props.loaderchange('true');
          const addPatient = fetchPatientDetailsUuid(payload);
          const response = await dispatch(addPatient);
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0];
            const namePat = data?.titles + ' ' + data?.first_name + ' ' + data?.last_name;
            if (e.target.name === 'patientId1') {
              setPatientOne_UUId(data?.id);
              setFormData({
                ...formData,
                patientName1: namePat,
                age1: data?.age,
                gender1: data?.gender,
                patientId1: text
              });
            }
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
          return;
        };

        fetchData();
      } else {
        if (e.target.name === 'patientId1') {
          setFormData({
            ...formData,
            patientId1: e.target.value
          });
        }
      }
    } else {
      setFormData({...formData, [e.target.name]: e.target.value});
      if (e.target.name === 'nextappointment') {
        const dateTime = e.target.value.split('T');
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData.p_uhid,
          name: `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
          status: 'Not Visited',
          notes: 'Booking Visit',
          patient_id: patientId
        });
      }
    }
  };

  const renderReportfield = (name, value, options = {}) => {
    const {styleSec = {}, styleLabel = {}, styleSpan = {}} = options;

    return (
      <>
        <section style={{...styleSec, margin: '0 10px 10px 10px', display: 'flex'}}>
          <label
            style={{
              ...styleLabel,
              fontWeight: '600',
              marginRight: '5px',
              width: 'max-content'
            }}>
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };

  const renderTableTD = value => {
    return <td style={{border: '1px solid black', textAlign: 'center'}}>{value}</td>;
  };
  const renderTableTH = value => {
    return <th style={{border: '1px solid black', textAlign: 'center'}}>{value}</th>;
  };
  const handlesubmit = () => {
    props.loaderchange('false');

    try {
      if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && props.patientsData.p_uhid.length === 10) {
        setshow(true);
        // Set timeout to handle async report creation
        setTimeout(async () => {
          // Get HTML payload
          const htmlPayload = document.getElementById('PretermLabourReportGenerateWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'Preterm Labour'

            }
          };

          // Dispatch action to create patient report
          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
            Swal.fire({
              title: 'Successful.',
              text: 'Record added successful.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            props.loaderchange('false');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            // props.popuptext(response?.status?.message);
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        // Show error message for invalid patient ids
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='PretermLabour'>
      <div className='PretermLabour'>
        <div className='' style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img
              className='header_image'
              src={headerimage}
              style={{
                // width: "100%", height: "25vh", maxHeight: show ? "100px" : "400px"

                width: '100%',
                margin: '0 auto'
              }}></img>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              gap: '3px',
              backgroundColor: '#f7f7f7 ',
              borderRadius: '6px',
              padding: '16px 8px 16px 8px',
              gap: '3px'
            }}>
            <div style={{display: 'flex', gap: '16px', alignItems: 'center'}}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Patient ID</span>
                <span style={{fontWeight: 600}}>: </span>
                <input
                  type='text'
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  value={props.patientsData.p_uhid}
                  onChange={e => handleChange(e)}
                  name='patientId'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px'
                  }}
                />
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.p_uhid}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Patient Name</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
                name='patientName'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px',
                  color: '#000'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`} style={{width: '100%'}}>
                &nbsp;
                {`${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '125px 16px 250px',
                  alignItems: 'center '
                }}>
                <span style={{fontWeight: 600}}>Gender</span>
                <span style={{fontWeight: 600}}>: </span>
                <select
                  className={`createTime ${show ? 'hide' : 'show'}`}
                  onChange={e => handleChange(e)}
                  value={props.patientsData.gender}
                  name='gender'
                  style={{
                    border: '1px solid #ddd',
                    outline: 'none',
                    padding: '10px',
                    backgroundColor: 'white'
                  }}>
                  <option value={props.patientsData.gender} selected>
                    {props.patientsData.gender}
                  </option>
                  <option value='Male'>Male</option>
                  <option value='Female'>Female</option>
                  <option value='Others'>Others</option>
                  <option value='Decline to State'>Decline to State</option>
                </select>
                <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.gender}</span>
              </div>
            </div>

            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '125px 16px 250px',
                alignItems: 'center '
              }}>
              <span style={{fontWeight: 600}}>Age</span>
              <span style={{fontWeight: 600}}>: </span>
              <input
                type='text'
                className={`createTime ${show ? 'hide' : 'show'}`}
                onChange={e => handleChange(e)}
                value={props.patientsData.age}
                name='age1'
                style={{
                  border: '1px solid #ddd',
                  outline: 'none',
                  padding: '10px'
                }}
              />
              <span className={`input ${!show ? 'hide' : 'show'}`}>&nbsp;{props.patientsData.age}</span>
            </div>
          </div>
        </div>


        <div className='detail mt-3'>
          <h4>PRETERM / TERM LABOUR – WORK-UP CHART</h4>
        </div>

        {showTables.checkList && (
          <div className='detail'>
            <TemplateTable
              id='checkList'
              title=''
              headers={checkListHeaders}
              rows={checkListRows}
              onRowsChange={(id, newRows) => setCheckListRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('checkList')}
            />
          </div>
        )}

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT APPOINTMENT - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='PretermLabourReportGenerate'>
        <div id='PretermLabourReportGenerateWrap'>
          <Headers />
          <p class='Dani'></p>
          <div
            className='patient'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>

        
          {showTables.checkList && (
            <>
              <div style={{display: 'flex', marginTop: '10px'}}>
                <h4 style={{fontWeight: 600, marginRight: '5px'}}>PRETERM / TERM LABOUR – WORK-UP CHART</h4>
              </div>

              <div>
                <table
                  style={{
                    marginBottom: '10px',
                    border: '1px solid black',
                    width: '100%',
                    textAlign: 'center'
                  }}>
                  <thead>
                    <tr>{checkListHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                  </thead>
                  <tbody>
                    {checkListRows.map((row, i) => (
                      <tr key={i}>
                        {renderTableTD(row.date)}
                        {renderTableTD(row.hvs)}
                        {renderTableTD(row.urine_culture)}
                        {renderTableTD(row.cervical_length)}
                        {renderTableTD(row.wbc)}
                        {renderTableTD(row.medications)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}

    <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p class='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
